import * as React from 'react';

import MainDetails from '../../components/eventDetails/mainDetails';

export default function GuestResponse() {
    return (
        <MainDetails />
    )
}
